//------ COPY SLIDER STARTS ------//

jQuery(function(){ //equivalent of ready in jQ 3.0

    function handleSlideCopyChange(e) {
        var $container = jQuery(e.target);
        var current_slide = e.detail.currentSlide - 1;
        var $parent = $container.closest('.slider-copy');
        $container.find('.slider-copy__current-slide').html(e.detail.currentSlide);

        $container.find('.slider-copy__dot').each(function(index, ele){
            jQuery(ele).removeClass('slider-copy__dot--active');
            if(jQuery(this).data('slide')==current_slide) {
                jQuery(ele).addClass('slider-copy__dot--active');
            }

        });

        $parent.find('.slider-copy__slide-copy-container').removeClass('slider-copy__slide-copy-container--active');
        $parent.find('.slider-copy__slide-copy-container').each(function(index, ele){
            var $slide = jQuery(ele);


            if($slide.data('slide') == current_slide) {
                $slide.addClass('slider-copy__slide-copy-container--active');
            }

        });
    }

    function copySliderAriaSelectedDots() {

        for (var index = 0; index < copySlidesDots.length; index++) {
            var element = copySlidesDots[index];

            if (element.classList.contains('slider-copy__dot--active')) {
                element.setAttribute("aria-selected", "true");
            } else {
                element.setAttribute("aria-selected", "false");
            }
        }
    }

    function copySliderAriaHidden() {

        for (var index = 0; index < copySlides.length; index++) {
            var copySlide_aria_hidden = copySlides[index];

            if (copySlide_aria_hidden.classList.contains('active')) {
                copySlide_aria_hidden.setAttribute("aria-hidden", "false");
                copySlide_aria_hidden.setAttribute("tabindex", "0");
            } else {
                copySlide_aria_hidden.setAttribute("aria-hidden", "true");
               copySlide_aria_hidden.setAttribute("tabindex", "-1");
            };
        };
    };

    function initializeCopySlider() {
        //console.log("COPY slider initialized!");

        jQuery('.slider-copy__container').each(function(index, ele){
            var copy_slider = lory(ele, {
                infinite: 1,
                classNameFrame: 'slider-copy__frame',
                classNameSlideContainer: 'slider-copy__slides',
                classNamePrevCtrl: 'slider-copy__prev',
                classNameNextCtrl: 'slider-copy__next',
                slideSpeed: 500
            });
    
    
            jQuery(ele).on('click', '.slider-copy__dot', function(e){
                copy_slider.slideTo(jQuery(this).data('slide'));
                jQuery('.slider-copy__dot').removeClass('slider-copy__dot--active');
                jQuery(this).addClass('slider-copy__dot--active');
    
                copySliderAriaHidden();
                copySliderAriaSelectedDots();
                
                return false;
            });
    
    
            ele.addEventListener('after.lory.slide', handleSlideCopyChange);
        });
    }

    function postInitializeCopySlider() {
        for (var index = 0; index < copySlidesArrows.length; index++) {
            var copySlideArrows = copySlidesArrows[index];
    
            copySlideArrows.onclick = function () {
                copySliderAriaHidden();
                copySliderAriaSelectedDots();
            };
        };
    
        copySliderAriaHidden();
        copySliderAriaSelectedDots();
    }

    var copySlides = document.getElementsByClassName("slider-copy__slide");
    var copySlidesArrows = document.getElementsByClassName("slider-copy__arrow");
    var copySlidesDots = document.getElementsByClassName("slider-copy__dot");

    if (jQuery('.slider-copy__container').length) {
        initializeCopySlider();
        postInitializeCopySlider();
    }


    // FIX for slider in PJAX container
    jQuery(document).on('ready pjax:success', function() {
        if (jQuery('.slider-copy__container').length) {
            initializeCopySlider();
            postInitializeCopySlider();
        }
    });

});

//------ COPY SLIDER ENDS ------//